import React, { useEffect, useState } from 'react';
import arrowRight from '../../images/icons/arrowRight.svg'
import searchIcon from '../../images/icons/search.svg'
import CustomCarousel from '../../components/carousel';
import Card from '../../components/Card';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ColorRing } from 'react-loader-spinner';

function CategoryBody() {
    const [categories, setCategories] = useState(
        [{id:1,cat:'one'},{id:2,cat:'two'}]
    );

        const [cards, setCards] = useState([
            {
                image: 'https://via.placeholder.com/300', 
                label: 'Agriculture',
                title: 'Merilek Scholars',
                rating: 5,
                recommendations: '1234',
                address: '3891 Ranchview Dr. Richardson, California 62639',
            },
            {
                image: 'https://via.placeholder.com/300', 
                label: 'Agriculture',
                title: 'Merilek Scholars',
                rating: 4,
                recommendations: '1234',
                address: '3891 Ranchview Dr. Richardson, California 62639',
            },
            {
                image: 'https://via.placeholder.com/300', 
                label: 'Agriculture',
                title: 'Merilek Scholars',
                rating: 4,
                recommendations: '1234',
                address: '3891 Ranchview Dr. Richardson, California 62639',
            },
            {
                image: 'https://via.placeholder.com/300', 
                label: 'Agriculture',
                title: 'Merilek Scholars',
                rating: 4,
                recommendations: '1234',
                address: '3891 Ranchview Dr. Richardson, California 62639',
            },
            {
                image: 'https://via.placeholder.com/300', 
                label: 'Agriculture',
                title: 'Merilek Scholars',
                rating: 4,
                recommendations: '1234',
                address: '3891 Ranchview Dr. Richardson, California 62639',
            }
        ])
    let [fetched, setFetched] = useState()
    useEffect(() => {
        axios.get(process.env.REACT_APP_BASE_URL+'/Category/GetTopLevel',{})
        .then((res) => {
            if(res.status == 200){
                setCategories(res.data.data)
            }}
        ).then(() => {
            axios.get(process.env.REACT_APP_BASE_URL+'/Business/List/'+sessionStorage.getItem('categoryId'),{})
            .then((res2) => {
                if(res2.status == 200){
                    setCards(res2.data.data)
                    setFetched(1)
                }
                })
        })
        .catch((e) => {
            console.log(e)
        })
    }, [])
    const navigateToCategory = (id,name) => {
        sessionStorage.setItem('categoryId',id)
        sessionStorage.setItem('currentCategory',name)
        window.location.href='/businesses'
    }
    const [searchTerm, setSearchTerm] = useState("");
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
      };

      const filteredBusinesses = cards.filter((item) =>
        searchTerm ? item.name.toLowerCase().includes(searchTerm.toLowerCase()) : item.name
      );
    return (

        <div className='grid grid-cols-8 px-5 lg:px-20 py-10 lg:space-x-10 space-y-3 lg:space-y-0'>
            <div className='col-span-8 lg:col-span-2 flex flex-col space-y-5'>
                <div className='flex flex-row space-x-3 items-center'>
                    <Link to='/'>Home</Link>
                    <span><img src={arrowRight}/></span>
                    <span className='flex flex-row space-x-2 items-center'>
                        <span>{sessionStorage.getItem('currentCategory')}</span>
                        <span className='grid hidden p-1 bg-[#008B39] rounded-full'><span className='my-auto text-white'>234</span></span>
                    </span>
                </div>
                <div className='hidden lg:flex flex-col'>
                    <div className='rounded-t-[8px] font-[500] border-[1px] text-start p-3 text-[24px] lg:text-[24px]'>
                        All Categories
                    </div>
                    <div className='rounded-b-[8px] border-x-[1px] border-b-[1px] pb-10 flex flex-col'>
                        <div className='flex flex-col'>
                            {categories.map(({id,categoryName}) => {
                                return (
                                    <div className='flex flex-col px-3 pt-4'>
                                        <div className='flex flex-row justify-between'>
                                            <span onClick={() => navigateToCategory(id,categoryName)} className='cursor-pointer'>{categoryName}</span>
                                        </div>
                                        <div><hr></hr></div>
                                    </div>
                                )
                            })}

                        </div>
                    </div>
                </div>
            </div>
            <div className='col-span-8 lg:col-span-6 flex flex-col space-y-5'>
                <div className='flex flex-row justify-between relative'>
                    <span className='absolute top-5 left-5 z-50'><img src={searchIcon} className='' /></span>
                    <input value={searchTerm}
        onChange={handleSearchChange} className='relative rounded-[4px] outline-none border-[1px] h-[50px] pl-10 p-2 w-full lg:w-[50%]' placeholder='Search business name'/>
                </div>
                <div className=''>
                {fetched ? 
                    cards.length > 0 ?
                        <CustomCarousel
                            defaultItemsPerSlide={2}
                            defaultRows={3}
                            responsive={[
                                { breakpoint: 1024, itemsPerSlide: 1, rows: 2 },
                                { breakpoint: 768, itemsPerSlide: 2, rows: 2 },
                                { breakpoint: 480, itemsPerSlide: 2, rows: 3 },
                            ]}
                        >
                            {filteredBusinesses.map((item, index) => (
                                <Card key={index} className="" {...item}></Card>
                            ))}
                        </CustomCarousel>
                    :
                    <div className='font-semibold text-[20px]'>No results fetched, please check your internet or refresh.</div>
                :
                    <div className='items-center grid mx-auto w-[80px] h-[80px] text-center'>
                    <ColorRing
                        visible={true}
                        height="80"
                        width="80"
                        ariaLabel="color-ring-loading"
                        wrapperStyle={{}}
                        wrapperClass="color-ring-wrapper"
                        colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                        className="mx-auto"
                        />
                    </div>
                }
                </div>
            </div>
        </div>
    );
}

export default CategoryBody